import http from '../http'

const loginValidate = async (payload) => (await http.post('/admin/login/validate', payload)).data

const login = async (payload) => (await http.post('/admin/login', payload)).data

const recoveryPassword = async (payload) => (await http.post('/admin/password/recovery', payload)).data

const getAll = async (params = {}) => (await http.get('/admin', { params })).data

const create = async (payload) => (await http.post('/admin', payload)).data

const update = async (id, payload) => (await http.put(`/admin/${id}`, payload)).data

const updateMe = async (payload) => (await http.put('/admin', payload)).data

const updateMyPassword = async (payload) => (await http.put('/admin/password', payload)).data

const destroy = async (id) => (await http.delete(`/admin/${id}`)).data

export default {
  login,
  loginValidate,
  recoveryPassword,
  getAll,
  create,
  update,
  updateMe,
  updateMyPassword,
  destroy
}
